import type { DateRange } from 'react-day-picker';

export const isValidSingleValue = (value: unknown): value is Date => value instanceof Date;

export const isValidRangeValue = (value: unknown): value is DateRange =>
  typeof value === 'object' &&
  value !== null &&
  'from' in value &&
  'to' in value &&
  value.from instanceof Date &&
  value.to instanceof Date;

export const isValidMultipleValue = (value: unknown): value is Date[] =>
  Array.isArray(value) && value.length > 0 && value.every((v) => v instanceof Date);
